

// // import React, { useEffect, useState } from "react";
// // import {
// //   Dialog,
// //   DialogTitle,
// //   DialogContent,
// //   DialogActions,
// //   Button,
// //   TextField,
// //   Select,
// //   MenuItem,
// //   InputLabel,
// //   FormControl,
// //   Box,
// //   Typography,
// //   Alert,
// //   Divider,
// //   Stack,
// //   IconButton,
// //   Chip,
// // } from "@mui/material";
// // import CloseIcon from "@mui/icons-material/Close";
// // import StorefrontIcon from "@mui/icons-material/Storefront";
// // import EditIcon from "@mui/icons-material/Edit";
// // import PersonIcon from "@mui/icons-material/Person";
// // import PhoneIcon from "@mui/icons-material/Phone";
// // import EmailIcon from "@mui/icons-material/Email";
// // import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
// // import BadgeIcon from "@mui/icons-material/Badge";
// // import CategoryIcon from "@mui/icons-material/Category";
// // import BusinessIcon from "@mui/icons-material/Business";

// // import { createVendor, updateVendor } from "../services/api";

// // const VENDOR_TYPES = [
// //   { value: "INDIVIDUAL", label: "Individual Driver", description: "Single driver, owns vehicle" },
// //   { value: "FLEET", label: "Fleet / Cab Agency", description: "Company with multiple drivers" },
// //   { value: "AGGREGATOR_API", label: "Aggregator API", description: "Ola/Uber-style integration" },
// //   { value: "OTHER", label: "Other", description: "Custom vendor type" },
// // ];

// // const CATEGORIES = [
// //   { value: "RIDE", label: "Ride Booking", icon: "🚗" },
// //   { value: "IRON", label: "Iron Service", icon: "👔" },
// //   { value: "LAUNDRY", label: "Laundry", icon: "🧺" },
// // ];

// // const initialForm = {
// //   category: "RIDE",
// //   vendorName: "",
// //   vendorType: "INDIVIDUAL",
// //   contactPerson: "",
// //   contactNumber: "",
// //   email: "",
// //   vehicleNumber: "",
// //   licenseNumber: "",
// // };

// // const VendorDialog = ({ open, onClose, vendor, onSaved }) => {
// //   const [form, setForm] = useState(initialForm);
// //   const [submitting, setSubmitting] = useState(false);
// //   const [error, setError] = useState("");

// //   const isEditing = !!vendor;

// //   useEffect(() => {
// //     if (open) {
// //       if (vendor) {
// //         setForm({
// //           category: vendor.category || "RIDE",
// //           vendorName: vendor.vendorName || "",
// //           vendorType: vendor.vendorType || "INDIVIDUAL",
// //           contactPerson: vendor.contactPerson || "",
// //           contactNumber: vendor.contactNumber || "",
// //           email: vendor.email || "",
// //           vehicleNumber: vendor.vehicleNumber || "",
// //           licenseNumber: vendor.licenseNumber || "",
// //         });
// //       } else {
// //         setForm({ ...initialForm });
// //       }
// //       setError("");
// //     }
// //   }, [open, vendor]);

// //   const handleChange = (field) => (e) => {
// //     setForm((prev) => ({ ...prev, [field]: e.target.value }));
// //     setError("");
// //   };

// //   const handlePhoneChange = (e) => {
// //     const v = e.target.value.replace(/\D/g, "");
// //     if (v.length <= 10) {
// //       setForm((prev) => ({ ...prev, contactNumber: v }));
// //       setError("");
// //     }
// //   };

// //   const handleSubmit = async () => {
// //     const vendorName = form.vendorName.trim();
// //     const contactPerson = form.contactPerson.trim();
// //     const contactNumber = form.contactNumber.trim();
// //     const email = form.email.trim();
// //     const vehicleNumber = form.vehicleNumber.trim();
// //     const licenseNumber = form.licenseNumber.trim();

// //     if (!vendorName) {
// //       setError("Vendor name is required");
// //       return;
// //     }
// //     if (!contactPerson) {
// //       setError("Contact person is required");
// //       return;
// //     }
// //     if (!contactNumber) {
// //       setError("Contact number is required");
// //       return;
// //     }
// //     if (!/^\d{10}$/.test(contactNumber)) {
// //       setError("Contact number must be exactly 10 digits");
// //       return;
// //     }
// //     if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
// //       setError("Please enter a valid email address");
// //       return;
// //     }

// //     const payload = {
// //       category: form.category,
// //       vendorName,
// //       vendorType: form.vendorType,
// //       contactPerson,
// //       contactNumber,
// //       email: email || null,
// //       vehicleNumber: vehicleNumber || null,
// //       licenseNumber: licenseNumber || null,
// //     };

// //     setSubmitting(true);
// //     setError("");

// //     try {
// //       if (isEditing) {
// //         await updateVendor(vendor.vendorId, payload);
// //         onSaved("Vendor updated successfully");
// //       } else {
// //         await createVendor(payload);
// //         onSaved("Vendor created successfully");
// //       }
// //     } catch (err) {
// //       setError(err.response?.data?.message || "Operation failed");
// //     } finally {
// //       setSubmitting(false);
// //     }
// //   };

// //   // Section label component
// //   const SectionLabel = ({ children }) => (
// //     <Typography
// //       variant="caption"
// //       color="text.secondary"
// //       fontWeight={600}
// //       sx={{
// //         textTransform: "uppercase",
// //         letterSpacing: 0.5,
// //         mb: 1,
// //         display: "block",
// //       }}
// //     >
// //       {children}
// //     </Typography>
// //   );

// //   return (
// //     <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
// //       {/* Header */}
// //       <DialogTitle sx={{ pb: 1, pr: 6 }}>
// //         <Box display="flex" alignItems="center" gap={1.5}>
// //           <Box
// //             sx={{
// //               width: 40,
// //               height: 40,
// //               borderRadius: 2,
// //               bgcolor: isEditing ? "warning.main" : "primary.main",
// //               display: "flex",
// //               alignItems: "center",
// //               justifyContent: "center",
// //               color: "white",
// //             }}
// //           >
// //             {isEditing ? <EditIcon /> : <StorefrontIcon />}
// //           </Box>
// //           <Box>
// //             <Typography variant="h6" fontWeight="bold">
// //               {isEditing ? "Edit Vendor" : "Add New Vendor"}
// //             </Typography>
// //             <Typography variant="caption" color="text.secondary">
// //               {isEditing ? `Vendor ID: #${vendor?.vendorId}` : "Add a new driver or vendor to your roster"}
// //             </Typography>
// //           </Box>
// //         </Box>
// //         <IconButton
// //           onClick={onClose}
// //           sx={{ position: "absolute", right: 12, top: 12 }}
// //           size="small"
// //         >
// //           <CloseIcon />
// //         </IconButton>
// //       </DialogTitle>

// //       <Divider />

// //       <DialogContent sx={{ pt: 3 }}>
// //         <Stack spacing={3}>
// //           {error && (
// //             <Alert severity="error" onClose={() => setError("")}>
// //               {error}
// //             </Alert>
// //           )}

// //           {/* Service Category */}
// //           <Box>
// //             <SectionLabel>Service Category</SectionLabel>
// //             <FormControl fullWidth>
// //               <InputLabel>Category</InputLabel>
// //               <Select
// //                 value={form.category}
// //                 label="Category"
// //                 onChange={handleChange("category")}
// //                 disabled={isEditing}
// //                 startAdornment={
// //                   <CategoryIcon sx={{ fontSize: 20, color: "text.secondary", ml: 1, mr: 0.5 }} />
// //                 }
// //               >
// //                 {CATEGORIES.map((c) => (
// //                   <MenuItem key={c.value} value={c.value}>
// //                     <Box display="flex" alignItems="center" gap={1}>
// //                       <span style={{ fontSize: 18 }}>{c.icon}</span>
// //                       <Typography variant="body2">{c.label}</Typography>
// //                     </Box>
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //               {isEditing && (
// //                 <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
// //                   Category cannot be changed after creation
// //                 </Typography>
// //               )}
// //             </FormControl>
// //           </Box>

// //           {/* Vendor Type */}
// //           <Box>
// //             <SectionLabel>Vendor Type</SectionLabel>
// //             <FormControl fullWidth>
// //               <InputLabel>Type</InputLabel>
// //               <Select
// //                 value={form.vendorType}
// //                 label="Type"
// //                 onChange={handleChange("vendorType")}
// //                 renderValue={(selected) => {
// //                   const type = VENDOR_TYPES.find((t) => t.value === selected);
// //                   return (
// //                     <Box display="flex" alignItems="center" gap={1}>
// //                       <BusinessIcon sx={{ fontSize: 18, color: "text.secondary" }} />
// //                       <Typography variant="body2">{type?.label}</Typography>
// //                     </Box>
// //                   );
// //                 }}
// //               >
// //                 {VENDOR_TYPES.map((t) => (
// //                   <MenuItem key={t.value} value={t.value} sx={{ py: 1.5 }}>
// //                     <Box>
// //                       <Typography variant="body2" fontWeight={500}>
// //                         {t.label}
// //                       </Typography>
// //                       <Typography variant="caption" color="text.secondary">
// //                         {t.description}
// //                       </Typography>
// //                     </Box>
// //                   </MenuItem>
// //                 ))}
// //               </Select>
// //             </FormControl>
// //           </Box>

// //           <Divider />

// //           {/* Vendor Information */}
// //           <Box>
// //             <SectionLabel>Vendor Information</SectionLabel>
// //             <Stack spacing={2}>
// //               <TextField
// //                 label="Vendor Name"
// //                 required
// //                 value={form.vendorName}
// //                 onChange={handleChange("vendorName")}
// //                 fullWidth
// //                 autoFocus
// //                 placeholder="e.g., Rajesh Kumar or Rapid Cabs Pvt Ltd"
// //                 InputProps={{
// //                   startAdornment: (
// //                     <StorefrontIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />
// //                   ),
// //                 }}
// //               />

// //               <TextField
// //                 label="Contact Person"
// //                 required
// //                 value={form.contactPerson}
// //                 onChange={handleChange("contactPerson")}
// //                 fullWidth
// //                 placeholder="Primary contact name"
// //                 InputProps={{
// //                   startAdornment: (
// //                     <PersonIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />
// //                   ),
// //                 }}
// //               />
// //             </Stack>
// //           </Box>

// //           {/* Contact Details */}
// //           <Box>
// //             <SectionLabel>Contact Details</SectionLabel>
// //             <Stack spacing={2}>
// //               <TextField
// //                 label="Phone Number"
// //                 required
// //                 value={form.contactNumber}
// //                 onChange={handlePhoneChange}
// //                 fullWidth
// //                 type="tel"
// //                 placeholder="10-digit mobile number"
// //                 InputProps={{
// //                   startAdornment: (
// //                     <PhoneIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />
// //                   ),
// //                 }}
// //                 inputProps={{
// //                   inputMode: "numeric",
// //                   pattern: "[0-9]*",
// //                   maxLength: 10,
// //                 }}
// //                 helperText={
// //                   form.contactNumber.length > 0 && form.contactNumber.length < 10
// //                     ? `${10 - form.contactNumber.length} more digits required`
// //                     : ""
// //                 }
// //               />

// //               <TextField
// //                 label="Email"
// //                 type="email"
// //                 value={form.email}
// //                 onChange={handleChange("email")}
// //                 fullWidth
// //                 placeholder="vendor@example.com"
// //                 InputProps={{
// //                   startAdornment: (
// //                     <EmailIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />
// //                   ),
// //                 }}
// //                 helperText="Optional"
// //               />
// //             </Stack>
// //           </Box>

// //           {/* Vehicle Details — only for INDIVIDUAL/FLEET */}
// //           {(form.vendorType === "INDIVIDUAL" || form.vendorType === "FLEET") && (
// //             <Box>
// //               <SectionLabel>Vehicle & License (Optional)</SectionLabel>
// //               <Stack spacing={2}>
// //                 <TextField
// //                   label="Vehicle Number"
// //                   value={form.vehicleNumber}
// //                   onChange={handleChange("vehicleNumber")}
// //                   fullWidth
// //                   placeholder="DL 1A 1234"
// //                   InputProps={{
// //                     startAdornment: (
// //                       <DirectionsCarIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />
// //                     ),
// //                   }}
// //                 />

// //                 <TextField
// //                   label="Driving License Number"
// //                   value={form.licenseNumber}
// //                   onChange={handleChange("licenseNumber")}
// //                   fullWidth
// //                   placeholder="DL-1234567890"
// //                   InputProps={{
// //                     startAdornment: (
// //                       <BadgeIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />
// //                     ),
// //                   }}
// //                 />
// //               </Stack>
// //             </Box>
// //           )}

// //           {/* Required fields note */}
// //           <Box
// //             sx={{
// //               p: 1.5,
// //               bgcolor: "info.50",
// //               border: "1px solid",
// //               borderColor: "info.light",
// //               borderRadius: 1,
// //             }}
// //           >
// //             <Typography variant="caption" color="info.dark">
// //               Fields marked with * are required. All other fields are optional.
// //             </Typography>
// //           </Box>
// //         </Stack>
// //       </DialogContent>

// //       <Divider />

// //       <DialogActions sx={{ px: 3, py: 2 }}>
// //         <Button onClick={onClose} disabled={submitting}>
// //           Cancel
// //         </Button>
// //         <Button
// //           onClick={handleSubmit}
// //           variant="contained"
// //           disabled={submitting}
// //           startIcon={submitting ? null : isEditing ? <EditIcon /> : <StorefrontIcon />}
// //           sx={{ px: 3 }}
// //           color={isEditing ? "warning" : "primary"}
// //         >
// //           {submitting
// //             ? isEditing
// //               ? "Updating..."
// //               : "Creating..."
// //             : isEditing
// //             ? "Update Vendor"
// //             : "Create Vendor"}
// //         </Button>
// //       </DialogActions>
// //     </Dialog>
// //   );
// // };

// // export default VendorDialog;

// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   TextField,
//   Select,
//   MenuItem,
//   InputLabel,
//   FormControl,
//   Box,
//   Typography,
//   Alert,
//   Divider,
//   Stack,
//   IconButton,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import StorefrontIcon from "@mui/icons-material/Storefront";
// import EditIcon from "@mui/icons-material/Edit";
// import PersonIcon from "@mui/icons-material/Person";
// import PhoneIcon from "@mui/icons-material/Phone";
// import EmailIcon from "@mui/icons-material/Email";
// import HomeIcon from "@mui/icons-material/Home";
// import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
// import BadgeIcon from "@mui/icons-material/Badge";
// import CategoryIcon from "@mui/icons-material/Category";
// import BusinessIcon from "@mui/icons-material/Business";
// import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
// import DescriptionIcon from "@mui/icons-material/Description";
// import ReceiptIcon from "@mui/icons-material/Receipt";

// import { createVendor, updateVendor } from "../services/api";

// const VENDOR_TYPES = [
//   { value: "INDIVIDUAL", label: "Individual Driver", description: "Single driver, owns vehicle" },
//   { value: "FLEET", label: "Fleet / Cab Agency", description: "Company with multiple drivers" },
//   { value: "AGGREGATOR_API", label: "Aggregator API", description: "Ola/Uber-style integration" },
//   { value: "OTHER", label: "Other", description: "Custom vendor type" },
// ];

// const CATEGORIES = [
//   { value: "RIDE", label: "Ride Booking", icon: "🚗" },
//   { value: "IRON", label: "Iron Service", icon: "👔" },
//   { value: "LAUNDRY", label: "Laundry", icon: "🧺" },
// ];

// const initialForm = {
//   category: "RIDE",
//   vendorName: "",
//   vendorType: "INDIVIDUAL",
//   contactPerson: "",
//   contactNumber: "",
//   email: "",
//   address: "",
//   // Business identity
//   gstNumber: "",
//   panNumber: "",
//   businessLicenseNumber: "",
//   // Documents (URLs)
//   addressProofUrl: "",
//   gstCertificateUrl: "",
//   panCardUrl: "",
//   businessLicenseUrl: "",
//   agreementDocumentUrl: "",
//   // Vehicle
//   vehicleNumber: "",
//   licenseNumber: "",
//   // Bank
//   bankAccountNumber: "",
//   bankIfscCode: "",
//   bankAccountHolderName: "",
// };

// const VendorDialog = ({ open, onClose, vendor, onSaved }) => {
//   const [form, setForm] = useState(initialForm);
//   const [submitting, setSubmitting] = useState(false);
//   const [error, setError] = useState("");

//   const isEditing = !!vendor;

//   useEffect(() => {
//     if (open) {
//       if (vendor) {
//         setForm({
//           category: vendor.category || "RIDE",
//           vendorName: vendor.vendorName || "",
//           vendorType: vendor.vendorType || "INDIVIDUAL",
//           contactPerson: vendor.contactPerson || "",
//           contactNumber: vendor.contactNumber || "",
//           email: vendor.email || "",
//           address: vendor.address || "",
//           gstNumber: vendor.gstNumber || "",
//           panNumber: vendor.panNumber || "",
//           businessLicenseNumber: vendor.businessLicenseNumber || "",
//           addressProofUrl: vendor.addressProofUrl || "",
//           gstCertificateUrl: vendor.gstCertificateUrl || "",
//           panCardUrl: vendor.panCardUrl || "",
//           businessLicenseUrl: vendor.businessLicenseUrl || "",
//           agreementDocumentUrl: vendor.agreementDocumentUrl || "",
//           vehicleNumber: vendor.vehicleNumber || "",
//           licenseNumber: vendor.licenseNumber || "",
//           bankAccountNumber: vendor.bankAccountNumber || "",
//           bankIfscCode: vendor.bankIfscCode || "",
//           bankAccountHolderName: vendor.bankAccountHolderName || "",
//         });
//       } else {
//         setForm({ ...initialForm });
//       }
//       setError("");
//     }
//   }, [open, vendor]);

//   const handleChange = (field) => (e) => {
//     setForm((prev) => ({ ...prev, [field]: e.target.value }));
//     setError("");
//   };

//   const handlePhoneChange = (e) => {
//     const v = e.target.value.replace(/\D/g, "");
//     if (v.length <= 10) {
//       setForm((prev) => ({ ...prev, contactNumber: v }));
//       setError("");
//     }
//   };

//   const handleSubmit = async () => {
//     const trimmed = {
//       vendorName: form.vendorName.trim(),
//       contactPerson: form.contactPerson.trim(),
//       contactNumber: form.contactNumber.trim(),
//       email: form.email.trim(),
//       address: form.address.trim(),
//       gstNumber: form.gstNumber.trim(),
//       panNumber: form.panNumber.trim(),
//       businessLicenseNumber: form.businessLicenseNumber.trim(),
//       addressProofUrl: form.addressProofUrl.trim(),
//       gstCertificateUrl: form.gstCertificateUrl.trim(),
//       panCardUrl: form.panCardUrl.trim(),
//       businessLicenseUrl: form.businessLicenseUrl.trim(),
//       agreementDocumentUrl: form.agreementDocumentUrl.trim(),
//       vehicleNumber: form.vehicleNumber.trim(),
//       licenseNumber: form.licenseNumber.trim(),
//       bankAccountNumber: form.bankAccountNumber.trim(),
//       bankIfscCode: form.bankIfscCode.trim().toUpperCase(),
//       bankAccountHolderName: form.bankAccountHolderName.trim(),
//     };

//     if (!trimmed.vendorName) return setError("Vendor name is required");
//     if (!trimmed.contactPerson) return setError("Contact person is required");
//     if (!trimmed.contactNumber) return setError("Contact number is required");
//     if (!/^\d{10}$/.test(trimmed.contactNumber))
//       return setError("Contact number must be exactly 10 digits");
//     if (trimmed.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed.email))
//       return setError("Please enter a valid email address");
//     if (trimmed.panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(trimmed.panNumber))
//       return setError("Invalid PAN format (e.g., ABCDE1234F)");
//     if (trimmed.bankIfscCode && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(trimmed.bankIfscCode))
//       return setError("Invalid IFSC code format");

//     const payload = {
//       category: form.category,
//       vendorType: form.vendorType,
//       ...trimmed,
//       // Convert empty strings to null
//       email: trimmed.email || null,
//       address: trimmed.address || null,
//       gstNumber: trimmed.gstNumber || null,
//       panNumber: trimmed.panNumber || null,
//       businessLicenseNumber: trimmed.businessLicenseNumber || null,
//       addressProofUrl: trimmed.addressProofUrl || null,
//       gstCertificateUrl: trimmed.gstCertificateUrl || null,
//       panCardUrl: trimmed.panCardUrl || null,
//       businessLicenseUrl: trimmed.businessLicenseUrl || null,
//       agreementDocumentUrl: trimmed.agreementDocumentUrl || null,
//       vehicleNumber: trimmed.vehicleNumber || null,
//       licenseNumber: trimmed.licenseNumber || null,
//       bankAccountNumber: trimmed.bankAccountNumber || null,
//       bankIfscCode: trimmed.bankIfscCode || null,
//       bankAccountHolderName: trimmed.bankAccountHolderName || null,
//     };

//     setSubmitting(true);
//     setError("");

//     try {
//       if (isEditing) {
//         await updateVendor(vendor.vendorId, payload);
//         onSaved("Vendor updated successfully");
//       } else {
//         await createVendor(payload);
//         onSaved("Vendor created. Awaiting verification.");
//       }
//     } catch (err) {
//       setError(err.response?.data?.message || "Operation failed");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const SectionLabel = ({ children }) => (
//     <Typography
//       variant="caption"
//       color="text.secondary"
//       fontWeight={600}
//       sx={{
//         textTransform: "uppercase",
//         letterSpacing: 0.5,
//         mb: 1,
//         display: "block",
//       }}
//     >
//       {children}
//     </Typography>
//   );

//   const isFleet = form.vendorType === "FLEET";

//   return (
//     <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
//       <DialogTitle sx={{ pb: 1, pr: 6 }}>
//         <Box display="flex" alignItems="center" gap={1.5}>
//           <Box
//             sx={{
//               width: 40,
//               height: 40,
//               borderRadius: 2,
//               bgcolor: isEditing ? "warning.main" : "primary.main",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               color: "white",
//             }}
//           >
//             {isEditing ? <EditIcon /> : <StorefrontIcon />}
//           </Box>
//           <Box>
//             <Typography variant="h6" fontWeight="bold">
//               {isEditing ? "Edit Vendor" : "Add New Vendor"}
//             </Typography>
//             <Typography variant="caption" color="text.secondary">
//               {isEditing
//                 ? `Vendor ID: #${vendor?.vendorId}`
//                 : "New vendors require admin verification before activation"}
//             </Typography>
//           </Box>
//         </Box>
//         <IconButton
//           onClick={onClose}
//           sx={{ position: "absolute", right: 12, top: 12 }}
//           size="small"
//         >
//           <CloseIcon />
//         </IconButton>
//       </DialogTitle>

//       <Divider />

//       <DialogContent sx={{ pt: 3 }}>
//         <Stack spacing={3}>
//           {error && (
//             <Alert severity="error" onClose={() => setError("")}>
//               {error}
//             </Alert>
//           )}

//           {!isEditing && (
//             <Alert severity="info">
//               After creating, this vendor will be in PENDING state. Upload required
//               documents and verify before they can take rides.
//             </Alert>
//           )}

//           {/* Service category */}
//           <Box>
//             <SectionLabel>Service Category</SectionLabel>
//             <FormControl fullWidth>
//               <InputLabel>Category</InputLabel>
//               <Select
//                 value={form.category}
//                 label="Category"
//                 onChange={handleChange("category")}
//                 disabled={isEditing}
//                 startAdornment={
//                   <CategoryIcon sx={{ fontSize: 20, color: "text.secondary", ml: 1, mr: 0.5 }} />
//                 }
//               >
//                 {CATEGORIES.map((c) => (
//                   <MenuItem key={c.value} value={c.value}>
//                     <Box display="flex" alignItems="center" gap={1}>
//                       <span>{c.icon}</span>
//                       <Typography variant="body2">{c.label}</Typography>
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>

//           {/* Vendor type */}
//           <Box>
//             <SectionLabel>Vendor Type</SectionLabel>
//             <FormControl fullWidth>
//               <InputLabel>Type</InputLabel>
//               <Select
//                 value={form.vendorType}
//                 label="Type"
//                 onChange={handleChange("vendorType")}
//               >
//                 {VENDOR_TYPES.map((t) => (
//                   <MenuItem key={t.value} value={t.value} sx={{ py: 1.5 }}>
//                     <Box>
//                       <Typography variant="body2" fontWeight={500}>{t.label}</Typography>
//                       <Typography variant="caption" color="text.secondary">
//                         {t.description}
//                       </Typography>
//                     </Box>
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </Box>

//           <Divider />

//           {/* Vendor info */}
//           <Box>
//             <SectionLabel>Vendor Information</SectionLabel>
//             <Stack spacing={2}>
//               <TextField
//                 label="Vendor Name"
//                 required
//                 value={form.vendorName}
//                 onChange={handleChange("vendorName")}
//                 fullWidth
//                 autoFocus
//                 placeholder="e.g., Rajesh Kumar or Rapid Cabs Pvt Ltd"
//                 InputProps={{
//                   startAdornment: <StorefrontIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />

//               <TextField
//                 label="Contact Person"
//                 required
//                 value={form.contactPerson}
//                 onChange={handleChange("contactPerson")}
//                 fullWidth
//                 InputProps={{
//                   startAdornment: <PersonIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />

//               <TextField
//                 label="Address"
//                 value={form.address}
//                 onChange={handleChange("address")}
//                 fullWidth
//                 multiline
//                 rows={2}
//                 InputProps={{
//                   startAdornment: (
//                     <HomeIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1, mt: 1, alignSelf: "flex-start" }} />
//                   ),
//                 }}
//               />
//             </Stack>
//           </Box>

//           {/* Contact */}
//           <Box>
//             <SectionLabel>Contact Details</SectionLabel>
//             <Stack spacing={2}>
//               <TextField
//                 label="Phone Number"
//                 required
//                 value={form.contactNumber}
//                 onChange={handlePhoneChange}
//                 fullWidth
//                 type="tel"
//                 placeholder="10-digit mobile number"
//                 InputProps={{
//                   startAdornment: <PhoneIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//                 inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
//                 helperText={
//                   form.contactNumber.length > 0 && form.contactNumber.length < 10
//                     ? `${10 - form.contactNumber.length} more digits required`
//                     : ""
//                 }
//               />

//               <TextField
//                 label="Email"
//                 type="email"
//                 value={form.email}
//                 onChange={handleChange("email")}
//                 fullWidth
//                 placeholder="vendor@example.com"
//                 InputProps={{
//                   startAdornment: <EmailIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />
//             </Stack>
//           </Box>

//           <Divider />

//           {/* Business identity */}
//           <Box>
//             <SectionLabel>Business Identity</SectionLabel>
//             <Stack spacing={2}>
//               <TextField
//                 label="PAN Number"
//                 value={form.panNumber}
//                 onChange={(e) => setForm((p) => ({ ...p, panNumber: e.target.value.toUpperCase() }))}
//                 fullWidth
//                 placeholder="ABCDE1234F"
//                 InputProps={{
//                   startAdornment: <BadgeIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//                 inputProps={{ maxLength: 10 }}
//               />

//               <TextField
//                 label={`GST Number ${isFleet ? "*" : "(Optional)"}`}
//                 value={form.gstNumber}
//                 onChange={(e) => setForm((p) => ({ ...p, gstNumber: e.target.value.toUpperCase() }))}
//                 fullWidth
//                 required={isFleet}
//                 placeholder="29ABCDE1234F1Z5"
//                 InputProps={{
//                   startAdornment: <ReceiptIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />

//               <TextField
//                 label={`Business License Number ${isFleet ? "*" : "(Optional)"}`}
//                 value={form.businessLicenseNumber}
//                 onChange={handleChange("businessLicenseNumber")}
//                 fullWidth
//                 required={isFleet}
//                 InputProps={{
//                   startAdornment: <BusinessIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />
//             </Stack>
//           </Box>

//           {/* Vehicle info — only for non-aggregator */}
//           {form.vendorType !== "AGGREGATOR_API" && (
//             <Box>
//               <SectionLabel>Vehicle & Driving License (Optional)</SectionLabel>
//               <Stack spacing={2}>
//                 <TextField
//                   label="Vehicle Number"
//                   value={form.vehicleNumber}
//                   onChange={handleChange("vehicleNumber")}
//                   fullWidth
//                   placeholder="DL 1A 1234"
//                   InputProps={{
//                     startAdornment: <DirectionsCarIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                   }}
//                 />
//                 <TextField
//                   label="Driving License Number"
//                   value={form.licenseNumber}
//                   onChange={handleChange("licenseNumber")}
//                   fullWidth
//                   InputProps={{
//                     startAdornment: <BadgeIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                   }}
//                 />
//               </Stack>
//             </Box>
//           )}

//           <Divider />

//           {/* Documents */}
//           <Box>
//             <SectionLabel>Document URLs (paste uploaded file URLs)</SectionLabel>
//             <Alert severity="info" sx={{ mb: 2 }}>
//               Upload documents to your storage (S3/Cloudinary) first, then paste URLs here.
//               File upload UI coming soon.
//             </Alert>
//             <Stack spacing={2}>
//               <TextField
//                 label="Address Proof URL *"
//                 value={form.addressProofUrl}
//                 onChange={handleChange("addressProofUrl")}
//                 fullWidth
//                 placeholder="https://..."
//                 InputProps={{
//                   startAdornment: <DescriptionIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />
//               <TextField
//                 label="PAN Card URL *"
//                 value={form.panCardUrl}
//                 onChange={handleChange("panCardUrl")}
//                 fullWidth
//                 placeholder="https://..."
//                 InputProps={{
//                   startAdornment: <DescriptionIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />
//               <TextField
//                 label={`GST Certificate URL ${isFleet ? "*" : "(Optional)"}`}
//                 value={form.gstCertificateUrl}
//                 onChange={handleChange("gstCertificateUrl")}
//                 fullWidth
//                 required={isFleet}
//                 placeholder="https://..."
//                 InputProps={{
//                   startAdornment: <DescriptionIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />
//               <TextField
//                 label={`Business License URL ${isFleet ? "*" : "(Optional)"}`}
//                 value={form.businessLicenseUrl}
//                 onChange={handleChange("businessLicenseUrl")}
//                 fullWidth
//                 required={isFleet}
//                 placeholder="https://..."
//                 InputProps={{
//                   startAdornment: <DescriptionIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />
//               <TextField
//                 label="Service Agreement URL (Optional)"
//                 value={form.agreementDocumentUrl}
//                 onChange={handleChange("agreementDocumentUrl")}
//                 fullWidth
//                 placeholder="https://..."
//                 InputProps={{
//                   startAdornment: <DescriptionIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />
//             </Stack>
//           </Box>

//           <Divider />

//           {/* Bank details */}
//           <Box>
//             <SectionLabel>Bank Details (For Payments)</SectionLabel>
//             <Stack spacing={2}>
//               <TextField
//                 label="Account Holder Name"
//                 value={form.bankAccountHolderName}
//                 onChange={handleChange("bankAccountHolderName")}
//                 fullWidth
//                 InputProps={{
//                   startAdornment: <PersonIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />
//               <TextField
//                 label="Account Number"
//                 value={form.bankAccountNumber}
//                 onChange={(e) => {
//                   const v = e.target.value.replace(/\D/g, "");
//                   setForm((p) => ({ ...p, bankAccountNumber: v }));
//                 }}
//                 fullWidth
//                 InputProps={{
//                   startAdornment: <AccountBalanceIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//               />
//               <TextField
//                 label="IFSC Code"
//                 value={form.bankIfscCode}
//                 onChange={(e) =>
//                   setForm((p) => ({ ...p, bankIfscCode: e.target.value.toUpperCase() }))
//                 }
//                 fullWidth
//                 placeholder="SBIN0001234"
//                 InputProps={{
//                   startAdornment: <AccountBalanceIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} />,
//                 }}
//                 inputProps={{ maxLength: 11 }}
//               />
//             </Stack>
//           </Box>
//         </Stack>
//       </DialogContent>

//       <Divider />

//       <DialogActions sx={{ px: 3, py: 2 }}>
//         <Button onClick={onClose} disabled={submitting}>
//           Cancel
//         </Button>
//         <Button
//           onClick={handleSubmit}
//           variant="contained"
//           disabled={submitting}
//           startIcon={isEditing ? <EditIcon /> : <StorefrontIcon />}
//           color={isEditing ? "warning" : "primary"}
//           sx={{ px: 3 }}
//         >
//           {submitting
//             ? isEditing
//               ? "Updating..."
//               : "Creating..."
//             : isEditing
//             ? "Update Vendor"
//             : "Create Vendor"}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default VendorDialog;

import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Typography,
  Alert,
  Divider,
  Stack,
  IconButton,
  LinearProgress,
  Chip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import StorefrontIcon from "@mui/icons-material/Storefront";
import EditIcon from "@mui/icons-material/Edit";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import BadgeIcon from "@mui/icons-material/Badge";
import CategoryIcon from "@mui/icons-material/Category";
import BusinessIcon from "@mui/icons-material/Business";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import DescriptionIcon from "@mui/icons-material/Description";
import ReceiptIcon from "@mui/icons-material/Receipt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import { createVendor, updateVendor, uploadVendorDocument } from "../services/api";

const VENDOR_TYPES = [
  { value: "INDIVIDUAL", label: "Individual Driver", description: "Single driver, owns vehicle" },
  { value: "FLEET", label: "Fleet / Cab Agency", description: "Company with multiple drivers" },
  { value: "AGGREGATOR_API", label: "Aggregator API", description: "Ola/Uber-style integration" },
  { value: "OTHER", label: "Other", description: "Custom vendor type" },
];

const CATEGORIES = [
  { value: "RIDE", label: "Ride Booking", icon: "🚗" },
  { value: "IRON", label: "Iron Service", icon: "👔" },
  { value: "LAUNDRY", label: "Laundry", icon: "🧺" },
];

const DOC_FIELDS = (isFleet) => [
  { label: "Address Proof", required: true, fileType: "address-proof", urlField: "addressProofUrl" },
  { label: "PAN Card", required: true, fileType: "pan-card", urlField: "panCardUrl" },
  { label: "GST Certificate", required: isFleet, fileType: "gst-certificate", urlField: "gstCertificateUrl" },
  { label: "Business License", required: isFleet, fileType: "business-license", urlField: "businessLicenseUrl" },
  { label: "Service Agreement", required: false, fileType: "agreement", urlField: "agreementDocumentUrl" },
];

const initialForm = {
  category: "RIDE",
  vendorName: "",
  vendorType: "INDIVIDUAL",
  contactPerson: "",
  contactNumber: "",
  email: "",
  address: "",
  gstNumber: "",
  panNumber: "",
  businessLicenseNumber: "",
  addressProofUrl: "",
  gstCertificateUrl: "",
  panCardUrl: "",
  businessLicenseUrl: "",
  agreementDocumentUrl: "",
  vehicleNumber: "",
  licenseNumber: "",
  bankAccountNumber: "",
  bankIfscCode: "",
  bankAccountHolderName: "",
};

const VendorDialog = ({ open, onClose, vendor, onSaved }) => {
  const [form, setForm] = useState(initialForm);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  // Two-step state for new vendor
  const [step, setStep] = useState(1);           // 1 = basic info, 2 = documents
  const [createdVendorId, setCreatedVendorId] = useState(null);
  const [uploadingDoc, setUploadingDoc] = useState(null);

  const isEditing = !!vendor;
  const isFleet = form.vendorType === "FLEET";

  // Effective vendorId — either editing existing or just created
  const effectiveVendorId = isEditing ? vendor.vendorId : createdVendorId;

  useEffect(() => {
    if (open) {
      if (vendor) {
        setForm({
          category: vendor.category || "RIDE",
          vendorName: vendor.vendorName || "",
          vendorType: vendor.vendorType || "INDIVIDUAL",
          contactPerson: vendor.contactPerson || "",
          contactNumber: vendor.contactNumber || "",
          email: vendor.email || "",
          address: vendor.address || "",
          gstNumber: vendor.gstNumber || "",
          panNumber: vendor.panNumber || "",
          businessLicenseNumber: vendor.businessLicenseNumber || "",
          addressProofUrl: vendor.addressProofUrl || "",
          gstCertificateUrl: vendor.gstCertificateUrl || "",
          panCardUrl: vendor.panCardUrl || "",
          businessLicenseUrl: vendor.businessLicenseUrl || "",
          agreementDocumentUrl: vendor.agreementDocumentUrl || "",
          vehicleNumber: vendor.vehicleNumber || "",
          licenseNumber: vendor.licenseNumber || "",
          bankAccountNumber: vendor.bankAccountNumber || "",
          bankIfscCode: vendor.bankIfscCode || "",
          bankAccountHolderName: vendor.bankAccountHolderName || "",
        });
        setStep(1);  // editing always starts at step 1
      } else {
        setForm({ ...initialForm });
        setStep(1);
        setCreatedVendorId(null);
      }
      setError("");
    }
  }, [open, vendor]);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
    setError("");
  };

  const handlePhoneChange = (e) => {
    const v = e.target.value.replace(/\D/g, "");
    if (v.length <= 10) {
      setForm((prev) => ({ ...prev, contactNumber: v }));
      setError("");
    }
  };

  // Step 1 — validate and create/update vendor
  const handleStep1Submit = async () => {
    const trimmed = {
      vendorName: form.vendorName.trim(),
      contactPerson: form.contactPerson.trim(),
      contactNumber: form.contactNumber.trim(),
      email: form.email.trim(),
      address: form.address.trim(),
      gstNumber: form.gstNumber.trim(),
      panNumber: form.panNumber.trim(),
      businessLicenseNumber: form.businessLicenseNumber.trim(),
      vehicleNumber: form.vehicleNumber.trim(),
      licenseNumber: form.licenseNumber.trim(),
      bankAccountNumber: form.bankAccountNumber.trim(),
      bankIfscCode: form.bankIfscCode.trim().toUpperCase(),
      bankAccountHolderName: form.bankAccountHolderName.trim(),
    };

    if (!trimmed.vendorName) return setError("Vendor name is required");
    if (!trimmed.contactPerson) return setError("Contact person is required");
    if (!trimmed.contactNumber) return setError("Contact number is required");
    if (!/^\d{10}$/.test(trimmed.contactNumber))
      return setError("Contact number must be exactly 10 digits");
    if (trimmed.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed.email))
      return setError("Please enter a valid email address");
    if (trimmed.panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(trimmed.panNumber))
      return setError("Invalid PAN format (e.g., ABCDE1234F)");
    if (trimmed.bankIfscCode && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(trimmed.bankIfscCode))
      return setError("Invalid IFSC code format");

    const payload = {
      category: form.category,
      vendorType: form.vendorType,
      ...trimmed,
      email: trimmed.email || null,
      address: trimmed.address || null,
      gstNumber: trimmed.gstNumber || null,
      panNumber: trimmed.panNumber || null,
      businessLicenseNumber: trimmed.businessLicenseNumber || null,
      vehicleNumber: trimmed.vehicleNumber || null,
      licenseNumber: trimmed.licenseNumber || null,
      bankAccountNumber: trimmed.bankAccountNumber || null,
      bankIfscCode: trimmed.bankIfscCode || null,
      bankAccountHolderName: trimmed.bankAccountHolderName || null,
      // preserve existing doc URLs when editing
      addressProofUrl: form.addressProofUrl || null,
      gstCertificateUrl: form.gstCertificateUrl || null,
      panCardUrl: form.panCardUrl || null,
      businessLicenseUrl: form.businessLicenseUrl || null,
      agreementDocumentUrl: form.agreementDocumentUrl || null,
    };

    setSubmitting(true);
    setError("");

    try {
      if (isEditing) {
        await updateVendor(vendor.vendorId, payload);
        // For editing, go straight to step 2 for document uploads
        setStep(2);
      } else {
        const res = await createVendor(payload);
        const newVendorId = res.data.data.vendorId;
        setCreatedVendorId(newVendorId);
        setStep(2);  // move to document upload step
      }
    } catch (err) {
      setError(err.response?.data?.message || "Operation failed");
    } finally {
      setSubmitting(false);
    }
  };

  // Step 2 — upload document to S3
  const handleDocumentUpload = async (fileType, urlField, e) => {
    const file = e.target.files[0];
    if (!file || !effectiveVendorId) return;

    setUploadingDoc(fileType);
    setError("");
    try {
      const res = await uploadVendorDocument(effectiveVendorId, fileType, file);
      const url = res.data.data.url;
      setForm((prev) => ({ ...prev, [urlField]: url }));
    } catch (err) {
      setError(err.response?.data?.message || "Upload failed");
    } finally {
      setUploadingDoc(null);
    }
  };

  // Step 2 — done
  const handleDone = () => {
    onSaved(isEditing ? "Vendor updated successfully" : "Vendor created. Documents uploaded.");
  };

  const SectionLabel = ({ children }) => (
    <Typography
      variant="caption"
      color="text.secondary"
      fontWeight={600}
      sx={{ textTransform: "uppercase", letterSpacing: 0.5, mb: 1, display: "block" }}
    >
      {children}
    </Typography>
  );

  // Step indicator
  const StepIndicator = () => (
    <Box display="flex" alignItems="center" gap={1} mb={2}>
      <Chip
        label="1. Basic Info"
        size="small"
        color={step >= 1 ? "primary" : "default"}
        variant={step === 1 ? "filled" : "outlined"}
        icon={step > 1 ? <CheckCircleIcon /> : undefined}
      />
      <Box sx={{ flex: 1, height: 2, bgcolor: step > 1 ? "primary.main" : "divider" }} />
      <Chip
        label="2. Documents"
        size="small"
        color={step >= 2 ? "primary" : "default"}
        variant={step === 2 ? "filled" : "outlined"}
      />
    </Box>
  );

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pb: 1, pr: 6 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Box
            sx={{
              width: 40, height: 40, borderRadius: 2,
              bgcolor: isEditing ? "warning.main" : "primary.main",
              display: "flex", alignItems: "center", justifyContent: "center", color: "white",
            }}
          >
            {isEditing ? <EditIcon /> : <StorefrontIcon />}
          </Box>
          <Box>
            <Typography variant="h6" fontWeight="bold">
              {isEditing ? "Edit Vendor" : "Add New Vendor"}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {isEditing
                ? `Vendor ID: #${vendor?.vendorId}`
                : "New vendors require admin verification before activation"}
            </Typography>
          </Box>
        </Box>
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 3 }}>
        <Stack spacing={3}>
          {/* Step indicator — only for new vendor */}
          {!isEditing && <StepIndicator />}

          {error && <Alert severity="error" onClose={() => setError("")}>{error}</Alert>}

          {/* ── STEP 1 — Basic Info ── */}
          {step === 1 && (
            <>
              {!isEditing && (
                <Alert severity="info">
                  Fill in vendor details and click "Next". You'll upload documents in the next step.
                </Alert>
              )}

              {/* Service category */}
              <Box>
                <SectionLabel>Service Category</SectionLabel>
                <FormControl fullWidth>
                  <InputLabel>Category</InputLabel>
                  <Select
                    value={form.category}
                    label="Category"
                    onChange={handleChange("category")}
                    disabled={isEditing}
                    startAdornment={
                      <CategoryIcon sx={{ fontSize: 20, color: "text.secondary", ml: 1, mr: 0.5 }} />
                    }
                  >
                    {CATEGORIES.map((c) => (
                      <MenuItem key={c.value} value={c.value}>
                        <Box display="flex" alignItems="center" gap={1}>
                          <span>{c.icon}</span>
                          <Typography variant="body2">{c.label}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              {/* Vendor type */}
              <Box>
                <SectionLabel>Vendor Type</SectionLabel>
                <FormControl fullWidth>
                  <InputLabel>Type</InputLabel>
                  <Select value={form.vendorType} label="Type" onChange={handleChange("vendorType")}>
                    {VENDOR_TYPES.map((t) => (
                      <MenuItem key={t.value} value={t.value} sx={{ py: 1.5 }}>
                        <Box>
                          <Typography variant="body2" fontWeight={500}>{t.label}</Typography>
                          <Typography variant="caption" color="text.secondary">{t.description}</Typography>
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              <Divider />

              {/* Vendor info */}
              <Box>
                <SectionLabel>Vendor Information</SectionLabel>
                <Stack spacing={2}>
                  <TextField
                    label="Vendor Name" required value={form.vendorName}
                    onChange={handleChange("vendorName")} fullWidth autoFocus
                    placeholder="e.g., Rajesh Kumar or Rapid Cabs Pvt Ltd"
                    InputProps={{ startAdornment: <StorefrontIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                  />
                  <TextField
                    label="Contact Person" required value={form.contactPerson}
                    onChange={handleChange("contactPerson")} fullWidth
                    InputProps={{ startAdornment: <PersonIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                  />
                  <TextField
                    label="Address" value={form.address} onChange={handleChange("address")}
                    fullWidth multiline rows={2}
                    InputProps={{
                      startAdornment: <HomeIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1, mt: 1, alignSelf: "flex-start" }} />,
                    }}
                  />
                </Stack>
              </Box>

              {/* Contact */}
              <Box>
                <SectionLabel>Contact Details</SectionLabel>
                <Stack spacing={2}>
                  <TextField
                    label="Phone Number" required value={form.contactNumber}
                    onChange={handlePhoneChange} fullWidth type="tel"
                    placeholder="10-digit mobile number"
                    InputProps={{ startAdornment: <PhoneIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                    inputProps={{ inputMode: "numeric", pattern: "[0-9]*", maxLength: 10 }}
                    helperText={
                      form.contactNumber.length > 0 && form.contactNumber.length < 10
                        ? `${10 - form.contactNumber.length} more digits required` : ""
                    }
                  />
                  <TextField
                    label="Email" type="email" value={form.email}
                    onChange={handleChange("email")} fullWidth placeholder="vendor@example.com"
                    InputProps={{ startAdornment: <EmailIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                  />
                </Stack>
              </Box>

              <Divider />

              {/* Business identity */}
              <Box>
                <SectionLabel>Business Identity</SectionLabel>
                <Stack spacing={2}>
                  <TextField
                    label="PAN Number" value={form.panNumber}
                    onChange={(e) => setForm((p) => ({ ...p, panNumber: e.target.value.toUpperCase() }))}
                    fullWidth placeholder="ABCDE1234F"
                    InputProps={{ startAdornment: <BadgeIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                    inputProps={{ maxLength: 10 }}
                  />
                  <TextField
                    label={`GST Number ${isFleet ? "*" : "(Optional)"}`} value={form.gstNumber}
                    onChange={(e) => setForm((p) => ({ ...p, gstNumber: e.target.value.toUpperCase() }))}
                    fullWidth required={isFleet} placeholder="29ABCDE1234F1Z5"
                    InputProps={{ startAdornment: <ReceiptIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                  />
                  <TextField
                    label={`Business License Number ${isFleet ? "*" : "(Optional)"}`}
                    value={form.businessLicenseNumber} onChange={handleChange("businessLicenseNumber")}
                    fullWidth required={isFleet}
                    InputProps={{ startAdornment: <BusinessIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                  />
                </Stack>
              </Box>

              {/* Vehicle */}
              {form.vendorType !== "AGGREGATOR_API" && (
                <Box>
                  <SectionLabel>Vehicle & Driving License (Optional)</SectionLabel>
                  <Stack spacing={2}>
                    <TextField
                      label="Vehicle Number" value={form.vehicleNumber}
                      onChange={handleChange("vehicleNumber")} fullWidth placeholder="DL 1A 1234"
                      InputProps={{ startAdornment: <DirectionsCarIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                    />
                    <TextField
                      label="Driving License Number" value={form.licenseNumber}
                      onChange={handleChange("licenseNumber")} fullWidth
                      InputProps={{ startAdornment: <BadgeIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                    />
                  </Stack>
                </Box>
              )}

              <Divider />

              {/* Bank details */}
              <Box>
                <SectionLabel>Bank Details (For Payments)</SectionLabel>
                <Stack spacing={2}>
                  <TextField
                    label="Account Holder Name" value={form.bankAccountHolderName}
                    onChange={handleChange("bankAccountHolderName")} fullWidth
                    InputProps={{ startAdornment: <PersonIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                  />
                  <TextField
                    label="Account Number" value={form.bankAccountNumber}
                    onChange={(e) => {
                      const v = e.target.value.replace(/\D/g, "");
                      setForm((p) => ({ ...p, bankAccountNumber: v }));
                    }}
                    fullWidth
                    InputProps={{ startAdornment: <AccountBalanceIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                  />
                  <TextField
                    label="IFSC Code" value={form.bankIfscCode}
                    onChange={(e) => setForm((p) => ({ ...p, bankIfscCode: e.target.value.toUpperCase() }))}
                    fullWidth placeholder="SBIN0001234"
                    InputProps={{ startAdornment: <AccountBalanceIcon sx={{ fontSize: 20, color: "text.secondary", mr: 1 }} /> }}
                    inputProps={{ maxLength: 11 }}
                  />
                </Stack>
              </Box>
            </>
          )}

          {/* ── STEP 2 — Documents ── */}
          {step === 2 && (
            <>
              <Alert severity="success" icon={<CheckCircleIcon />}>
                {isEditing
                  ? `Vendor #${vendor.vendorId} updated. Upload or update documents below.`
                  : `Vendor created (ID: #${createdVendorId}). Now upload required documents.`}
              </Alert>

              <Box>
                <SectionLabel>Document Uploads</SectionLabel>
                <Stack spacing={2}>
                  {DOC_FIELDS(isFleet).map(({ label, required, fileType, urlField }) => (
                    <Box
                      key={fileType}
                      sx={{
                        border: "1px solid",
                        borderColor: form[urlField] ? "success.light" : "divider",
                        borderRadius: 1,
                        p: 1.5,
                        bgcolor: form[urlField] ? "success.50" : "grey.50",
                      }}
                    >
                      <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Box display="flex" alignItems="center" gap={1}>
                          <DescriptionIcon
                            sx={{ fontSize: 18, color: form[urlField] ? "success.main" : "text.secondary" }}
                          />
                          <Box>
                            <Typography variant="body2" fontWeight={500}>
                              {label}{required && " *"}
                            </Typography>
                            {form[urlField] && (
                              <Typography variant="caption" color="success.dark">
                                ✅ {form[urlField].split("/").pop()}
                              </Typography>
                            )}
                          </Box>
                        </Box>

                        <Button
                          component="label"
                          size="small"
                          variant={form[urlField] ? "outlined" : "contained"}
                          color={form[urlField] ? "success" : "primary"}
                          disabled={uploadingDoc === fileType}
                          startIcon={uploadingDoc === fileType ? null : <CloudUploadIcon />}
                          sx={{ minWidth: 110 }}
                        >
                          {uploadingDoc === fileType
                            ? "Uploading..."
                            : form[urlField]
                            ? "Re-upload"
                            : "Upload"}
                          <input
                            type="file"
                            hidden
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={(e) => handleDocumentUpload(fileType, urlField, e)}
                          />
                        </Button>
                      </Box>

                      {uploadingDoc === fileType && (
                        <LinearProgress sx={{ mt: 1, borderRadius: 1 }} />
                      )}
                    </Box>
                  ))}
                </Stack>
              </Box>

              <Alert severity="info">
                Documents marked * are required before admin can verify this vendor.
                You can also upload them later via Edit.
              </Alert>
            </>
          )}
        </Stack>
      </DialogContent>

      <Divider />

      <DialogActions sx={{ px: 3, py: 2 }}>
        {step === 1 && (
          <>
            <Button onClick={onClose} disabled={submitting}>Cancel</Button>
            <Button
              onClick={handleStep1Submit}
              variant="contained"
              disabled={submitting}
              startIcon={isEditing ? <EditIcon /> : <StorefrontIcon />}
              color={isEditing ? "warning" : "primary"}
              sx={{ px: 3 }}
            >
              {submitting
                ? isEditing ? "Saving..." : "Creating..."
                : isEditing ? "Save & Upload Docs" : "Next: Upload Documents"}
            </Button>
          </>
        )}

        {step === 2 && (
          <>
            {!isEditing && (
              <Button onClick={() => setStep(1)} disabled={!!uploadingDoc}>
                ← Back
              </Button>
            )}
            <Button
              onClick={handleDone}
              variant="contained"
              color="success"
              disabled={!!uploadingDoc}
              startIcon={<CheckCircleIcon />}
              sx={{ px: 3 }}
            >
              Done
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default VendorDialog;